import { useState } from "react";

import { ErroAPI, api, desde } from "../api.ts";
import { Cartao, Selo } from "../componentes/basicos.tsx";
import { useSessao } from "../sessao.tsx";
import { useDados } from "../usarDados.ts";

type Usuario = {
  id: number; login: string; nome: string; papel: string; ativo: boolean;
  precisa_trocar_senha: boolean; ultimo_login: string | null;
  criado_em: string; sessoes_ativas: number;
};

const PAPEL: Record<string, string> = {
  admin: "Administrador", suporte: "Suporte", leitura: "Consulta",
};

export function Usuarios() {
  const { usuario: eu } = useSessao();
  const { dados, erro, carregando, recarregar } = useDados<Usuario[]>("/usuarios");
  const [senhaNova, setSenhaNova] = useState<{ login: string; senha: string } | null>(null);
  const [falha, setFalha] = useState("");

  async function acao(fn: () => Promise<unknown>) {
    setFalha("");
    try { await fn(); recarregar(); }
    catch (e) { setFalha(e instanceof ErroAPI ? e.message : "Nao consegui concluir."); }
  }

  return (
    <>
      <h1>Usuarios do painel</h1>
      {falha && <div className="alerta alerta--erro">{falha}</div>}

      {senhaNova && (
        <Cartao titulo={`Senha temporaria de ${senhaNova.login}`}>
          <div className="codigo-destaque">{senhaNova.senha}</div>
          <p className="suave pequeno mb-0">
            Anote agora: ela nao volta a ser exibida. O painel exige a troca no primeiro acesso.
          </p>
        </Cartao>
      )}

      <Cartao titulo="Contas">
        {carregando && <div className="carregando">carregando...</div>}
        {erro && <div className="alerta alerta--erro">{erro}</div>}
        {dados && (
          <div className="tabela-rolagem">
            <table className="tabela">
              <thead>
                <tr>
                  <th>Login</th><th>Nome</th><th>Perfil</th><th>Ultimo acesso</th>
                  <th>Sessoes</th><th>Situacao</th><th></th>
                </tr>
              </thead>
              <tbody>
                {dados.map((u) => (
                  <tr key={u.id}>
                    <td className="tabela__mono">{u.login}</td>
                    <td>{u.nome}</td>
                    <td className="suave">{PAPEL[u.papel] ?? u.papel}</td>
                    <td className="suave pequeno">{desde(u.ultimo_login)}</td>
                    <td className="tabela__num">{u.sessoes_ativas}</td>
                    <td>
                      {u.ativo ? <Selo tom="ok">ativo</Selo> : <Selo tom="neutro">desativado</Selo>}
                      {u.precisa_trocar_senha && <Selo tom="aviso">trocar senha</Selo>}
                    </td>
                    <td className="direita">
                      <div className="linha" style={{ justifyContent: "flex-end" }}>
                        <button className="botao botao--secundario botao--pequeno" type="button"
                                onClick={() => void acao(async () => {
                                  const r = await api.post<{ senha: string }>(`/usuarios/${u.id}/senha`);
                                  setSenhaNova({ login: u.login, senha: r.senha });
                                })}>Resetar senha</button>
                        {u.sessoes_ativas > 0 && (
                          <button className="botao botao--secundario botao--pequeno" type="button"
                                  onClick={() => void acao(() => api.post(`/usuarios/${u.id}/sessoes`))}>
                            Encerrar sessoes
                          </button>
                        )}
                        {u.id !== eu?.id && (
                          <button className={`botao botao--pequeno ${u.ativo ? "botao--perigo" : "botao--secundario"}`}
                                  type="button"
                                  onClick={() => void acao(() =>
                                    api.post(`/usuarios/${u.id}/ativo`, { ativo: !u.ativo }))}>
                            {u.ativo ? "Desativar" : "Reativar"}
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Cartao>

      {/* Criar usuario e acao anual: fica abaixo da lista que se le todo dia. */}
      <Cartao titulo="Novo usuario">
        <form className="grade grade--3" onSubmit={(ev) => {
          ev.preventDefault();
          const f = new FormData(ev.currentTarget);
          void acao(async () => {
            const r = await api.post<{ usuario: Usuario; senha: string }>("/usuarios", {
              login: f.get("login"), nome: f.get("nome"), papel: f.get("papel"),
            });
            setSenhaNova({ login: r.usuario.login, senha: r.senha });
          });
        }}>
          <label className="campo"><span className="campo__rotulo">Login</span>
            <input type="text" name="login" required /></label>
          <label className="campo"><span className="campo__rotulo">Nome</span>
            <input type="text" name="nome" required /></label>
          <label className="campo"><span className="campo__rotulo">Perfil</span>
            <select name="papel" defaultValue="suporte">
              <option value="suporte">Suporte</option>
              <option value="leitura">Consulta</option>
              <option value="admin">Administrador</option>
            </select></label>
          <div style={{ alignSelf: "end" }}>
            <button className="botao" type="submit">Criar</button>
          </div>
        </form>
      </Cartao>
    </>
  );
}
